// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__MoDbJ","logo":"styles_logo__On7BL","logoutButton":"styles_logoutButton__ZCpCV"};